import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-functions-loop-bug',
  slug: 'loop-bug',
  title: 'Every handler says 3',
  type: 'bug-hunt',
  estSeconds: 300,
  contentVersion: 1,
});
